import { dispatchGaAndFacebookEvent } from "../../utils/analytics";
import { config } from "../../utils/config";
import { get } from "../../utils/cookies";
import { currencyFormatter, getPriceValue, formatCurrencyForGa } from "../../utils/currency";
import shippingUtils from "../../utils/shipping";
import {getCountryCallingCode} from 'libphonenumber-js';
import store from '../../store';
import { Page } from "../../enums/page";
import Cart from "../../models/cart";
import { getCart } from "../../store/newCart";
import { ReOrder } from "../../enums/reOrder";
import { getSliderInfoFromLS, getCstmzrTypeInfoFromLS, addPCCFlag, setAttributes, addPathAndPosition, getCurrentLineItemId, addImportFeeForGa } from '../shopping-bag/ga-module';

declare const window: any;

const getShippingMethod = (cart) => {
  const shippingAddressState = cart?.shippingAddress?.state;
  let defaultShippingMethod : any = {}
  if(config('isNASite')) {
    const shippingMethodsNode = JSON.parse(config('shippingMethods'))
    defaultShippingMethod = shippingUtils.getDefaultShippingMethod(cart, shippingMethodsNode, shippingAddressState)
  }

  return defaultShippingMethod?.displayName ?? 'Standard Delivery'
}

const getCouponCode = (cart) => {
  return cart?.isCartTotalSavingAvailable || cart?.isShippingDiscountAvailable ? cart?.validDiscountCode : 'NA'
}

export const getPaymentMethod = (paymentMethod) => {
  let paymentMeth;
  if (get('expressCheckout') && ['US', 'CA'].includes(window.locale_details.country_code)) {
      paymentMeth = 'Paypal Checkout';
  }
  else if (get('applePayExpressCheckout') && ['US'].includes(window.locale_details.country_code)) {
    paymentMeth = 'Apple Pay Checkout'
  }
  else if (paymentMethod === 'credit_card' || paymentMethod === 'credit_card_adyen' || paymentMethod === 'credit_card_braintree') {
      paymentMeth = 'Credit card';
  }
  else if (paymentMethod === 'paypal') {
      paymentMeth = 'Paypal';
  }
  else if (paymentMethod === 'on_account') {
      paymentMeth = 'Bill me later';
  }
  else if (paymentMethod === 'paypal_pay_later') {
    paymentMeth = 'Paypal Paylater';
  }
  else if (paymentMethod === 'apple_pay_braintree') {
    paymentMeth = 'Apple Pay'
  }
  else if (paymentMethod === 'google_pay_adyen') {
    paymentMeth = 'Google Pay'
  }
  else if(paymentMethod === 'klarna_pay_now_adyen') {
    paymentMeth = 'Klarna Pay Now'
  }
  else if(paymentMethod === 'ideal_adyen') {
    paymentMeth = 'Ideal'
  }
  return paymentMeth;
}

export const dispatchPurchaseEvent = (order, user,shippingPrefill) => {
  const discountScope = getCart(store.getState(), {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn})?.data?.discountScope;
  const { paymentMethod, checkoutType }= store.getState().applicationState
  const paymentMeth = getPaymentMethod(paymentMethod);
  const _metaDataPayment = {
    event: "payment_method",
    payment_type: paymentMeth,
    step_name: "purchase", // based on type of payment
    step_no: 3,
    ...addPCCFlag(order?.hasPCCItem)
  };

  dispatchGaAndFacebookEvent(_metaDataPayment);
  const products = getProductsList(order, true, false);

  const productsList = Object.keys(order?.lineItems).map((lineItemId) => {
    const lineItem = order?.lineItems[lineItemId][0]?.data;
    return {
      id: lineItem?.webCode ? lineItem?.webCode :lineItem?.productFamilyName,
      name: lineItem?.name,
      price: lineItem?.unitPrice,
      quantity: lineItem?.quantity,
    };
  });
  let reorder = 0;
  products.forEach(product => {
    if(product.reorder){
      reorder = 1;
      return;
    }
  });
  const _metaData = {
    event: "purchase",
    gclid: "",
    checkout_type: checkoutType,
    transaction_id: order?.orderNumber,
    reorder:reorder,
    shipping_prefill : shippingPrefill,
    revenue: 
      getPriceValue(
        currencyFormatter(order?.cartSubtotal, order?.fractionDigits)
      ).replace(/ /g,"") ?? 0,
    tax: getPriceValue(currencyFormatter(order?.totalVAT, order?.fractionDigits)).replace(/ /g,""),
    shipping: getPriceValue(currencyFormatter(order?.totalDeliveryChargeExclVat, order?.fractionDigits)).replace(/ /g,"") || 0,
    coupon: getCouponCode(order) ?? 'NA',
    orderDiscount: order?.cartTotalSaving ? 
      getPriceValue(
        currencyFormatter(order?.cartTotalSaving, order?.fractionDigits)
      ).replace(/ /g,"") : 0,
    discountScope: discountScope || "",
    payment_type: paymentMeth,
    email_id: order?.customerEmail,
    mobile_no: '+' + getCountryCallingCode(order?.shippingAddress?.country) + order?.shippingAddress?.phone ?? '',
    products: products,
    shipping_method: config('isNASite') ? getShippingMethod(order) : 'Standard Delivery',
    ...addPCCFlag(order?.hasPCCItem)
  };
  _metaData['revenue_dec'] = formatCurrencyForGa(_metaData.revenue, order?.fractionDigits);
  _metaData['tax_dec'] = formatCurrencyForGa(_metaData.tax, order?.fractionDigits);
  _metaData['shipping_dec'] = formatCurrencyForGa(_metaData.shipping, order?.fractionDigits);

  const contentIds = Object.keys(order?.lineItems).map((lineItemId) => {
    const lineItem = order?.lineItems[lineItemId][0]?.data;
    return lineItem?.webCode ? lineItem?.webCode : lineItem?.productFamilyName;
  });

  const _fbMetaData = {
    event_name: "Purchase",
    custom_data: {
      value:
        getPriceValue(
          currencyFormatter(order?.cartSubtotal, order?.fractionDigits)
        ) || 0,
      currency: config("currency") || "",
      content_type: "product",
      content_ids: contentIds,
      contents: productsList,
    },
  };

  dispatchGaAndFacebookEvent(_metaData, _fbMetaData, Page.ORDERCONFIRMATION);

  dispatchABTastyTransaction(order, getCouponCode(order), paymentMeth);
  if (navigator.cookieEnabled) {
    window.localStorage.removeItem("_appliedCoupon");
    window.localStorage.removeItem("_gaActionField");
    window.localStorage.removeItem("_productHistory");
    window.localStorage.removeItem("cartAddress");
    window.localStorage.removeItem("__pdi__");
    window.localStorage.removeItem('qty-select-type');
  }
};

const dispatchABTastyTransaction = (order, coupon, paymentMethod) => {
  if (window.abtasty !== undefined && !!window.abtasty.send) {

    const payload = {
      tid: order?.orderNumber,
      ta: "purchase",
      tr: order?.cartTotalWithShipping / Math.pow(10,order?.fractionDigits)  || 0,
      ts: order?.totalDeliveryCharge / Math.pow(10,order?.fractionDigits) || 0,
      tt: order?.totalVAT/ Math.pow(10,order?.fractionDigits) || 0,
      tc: window?.locale_details?.currency || "IE",
      tcc: coupon,
      pm: paymentMethod,
      sm: config('isNASite') ? getShippingMethod(order) : 'Standard Delivery',
      icn: order?.mainItemCount
    }

    window.abtasty.send("transaction", payload);
    const productsList:any = [];
    Object.keys(order?.lineItems).forEach((lineItemId) => {
      const lineItems = order?.lineItems[lineItemId];
      lineItems.forEach(item => {
        if(item.type == 'upsell' || item.type == 'mainitem'){
          const itemData = item?.data;
          productsList.push({
            name: itemData?.name,
            price: itemData?.unitPrice / Math.pow(10,order?.fractionDigits) || 0,
            qty: itemData?.quantity,
            sku: `${itemData?.mcpSku},${itemData?.productKey}` ,
            category: itemData?.categoryName,
          })
        }
      })   
    });
    if (productsList && productsList.length) {
      productsList.forEach(function (product) {
        window.abtasty.send("item", {
          tid: order?.orderNumber,
          in: product?.name,
          ip: product?.price,
          iq: product?.qty,
          ic: product?.sku,
          iv: product?.category,
        });
      });
    }
  }
};

export const dispatchCheckoutStep2Event = (cart,shippingPrefill) => {
  const products = getProductsList(cart,false,false);
  let shippingType = config('isNASite') ? getShippingMethod(cart) : 'Standard Delivery'
  const checkoutType = get('expressCheckout');
  if(window.locale_details.country === 'US'){
      shippingType = shippingType || 'UPS Ground';
  } else if(window.locale_details.country === 'CA') {
      shippingType = shippingType || 'UPS Standard';
  } else {
      shippingType = shippingType || 'Standard';
  }
  const _metaData = {
      'event': 'checkout',
      'checkout_step': 2,
      'checkout_type': checkoutType ? 'paypal checkout' : 'national pen checkout',
      'step_name': 'Shipping',
      'products': products,
      'shipping_prefill': shippingPrefill,
      'revenue': getPriceValue(
        currencyFormatter(cart?.cartSubtotal, cart?.fractionDigits)
      ).replace(/ /g,"") || 0,
      'coupon': getCouponCode(cart) ?? 'NA',
      'orderDiscount': cart?.cartTotalSaving ? 
      getPriceValue(
        currencyFormatter(cart?.cartTotalSaving, cart?.fractionDigits)
      ).replace(/ /g,"") : 0,
      'tax': config('isNASite') ? 0 : getPriceValue(currencyFormatter(cart?.totalVAT, cart?.fractionDigits)).replace(/ /g,""),
      'shipping_method': shippingType,
      ...addPCCFlag(cart?.hasPCCItem),
      'shipping': getPriceValue(
        currencyFormatter(cart?.totalDeliveryChargeExclVat, cart?.fractionDigits)
      ).replace(/ /g,"") || 0
  };
  _metaData['revenue_dec'] = formatCurrencyForGa(_metaData.revenue, cart?.fractionDigits);
  _metaData['tax_dec'] = formatCurrencyForGa(_metaData.tax, cart?.fractionDigits);
  _metaData['shipping_dec'] = formatCurrencyForGa(_metaData.shipping, cart?.fractionDigits);

  const _fbMetaData = {
      'event_name': 'AddPaymentInfo'
  };

  dispatchGaAndFacebookEvent(_metaData, _fbMetaData, Page.CHECKOUTPAYMENT);
}

const getProductsList = (order, isPurchaseEvent = false, isSubmitArtworkEvent = false, isLogoUploaded?, isTextFilled?, areCommentsFilled?) => {
    const products:any = [];
    for (let x of Object.keys(order?.lineItems)) {
      for (let i = 0; i < order?.lineItems[x]?.length; i++) {
          if (order?.lineItems[x][i]?.type !== 'free' && order?.lineItems[x][i]?.type !== 'subitem' && order?.lineItems[x][i].type !== 'additionalcharge') {
              let attributes: any = [];
              if (order?.lineItems[x][i]?.type !== 'accessory') {
                const userSelectionInfo = order?.lineItems[x]?.[0]?.data?.productAttributes?.userSelectionInfo || [];
                const isProductOOS = order?.lineItems[x]?.[0]?.data?.isOutOfStock || false;
                let currentlineItemId = getCurrentLineItemId(order, x, i);
                const templateKey = order?.lineItems[x]?.[0]?.data?.customfield?.templateKey || '';
                attributes = setAttributes(userSelectionInfo,isProductOOS,currentlineItemId,templateKey);
              }
              let product : any = {
                  accessories: order?.lineItems[x][i]?.type === 'accessory' ? 1 : 0,
                  attributes: attributes,//lineitem.productAttributes.userSelectionInfo.[originalAttributeValue,originalAttributeKey]
                  class: order?.lineItems[x][i]?.type === 'accessory' ? order?.lineItems[x][i]?.data?.productFamilyName : order?.lineItems[x][0]?.data?.webCode ? order?.lineItems[x][0]?.data?.webCode : order?.lineItems[x][0]?.data?.productFamilyName,//lineitem.webCode
                  logo: order?.lineItems[x][i]?.type === 'mainitem' ? (getPriceValue(currencyFormatter(order?.lineItems[x][0]?.data?.itemLogoCharge, order?.fractionDigits)).replace(/ /g,"")) : 0,//lineitem.itemLogoCharge
                  name: order?.lineItems[x][i]?.type === 'upsell' ? order?.lineItems[x][0]?.data?.name : order?.lineItems[x][i]?.data?.name,//lineitem.name
                  product_type: (order?.lineItems[x][i]?.type === 'upsell' || order?.lineItems[x][i]?.type === 'accessory') ? order?.lineItems[x][0]?.data?.productType : order?.lineItems[x][i]?.data?.productType,
                  price: (getPriceValue(currencyFormatter(order?.lineItems[x][i]?.data?.unitPrice, order?.fractionDigits)).replace(/ /g,"")),
                  qty: order?.lineItems[x][i]?.type === 'mainitem' ? order?.lineItems[x][i]?.data?.totalQuantityWithSubItem : order?.lineItems[x][i]?.data?.quantity ?? 0,//lineitem.quantity
                  qty_free: order?.lineItems[x][0]?.data?.free_qty ? order.lineItems[x][0].data.free_qty : 0,
                  setup: (order?.lineItems[x][i]?.type === 'upsell' || order?.lineItems[x][i]?.type === 'accessory') ? 0 : getPriceValue(currencyFormatter(order?.lineItems[x][0]?.data?.lineItemSetupCharge,order?.fractionDigits)).replace(/ /g,""),//lineitem.lineItemSetupCharge
                  sku: (order?.lineItems[x][i]?.type === 'upsell' || order?.lineItems[x][i]?.type === 'mainitem') ? order?.lineItems[x][0]?.data?.mcpSku : order?.lineItems[x][i]?.data?.mcpSku,//lineitem.mcpSku
                  upsell: order?.lineItems[x][i]?.type === 'upsell' ? 1 : 0,
                  ...addPathAndPosition(order.lineItems[x][i].data?.id),
                  ...addMerchantCategory(order.lineItems[x][i].data?.id),
                  ...getSliderInfoFromLS(order?.lineItems[x][i]?.data?.id),
                  ...addPCCFlag(order?.lineItems[x][i]?.data?.postCheckOutCustomization),
                  ...addImportFeeForGa(order?.lineItems[x][i], order?.fractionDigits)
              };

              if (order?.lineItems[x][i]?.type === 'mainitem') {
                product.reorder = order?.lineItems[x][0]?.data?.customfield?.lineItemOrderType === ReOrder.REORDER_LINEITEM_ORDERTYPE ? 1 : 0;
              }
              const isUsg = order?.lineItems[x][i]?.data?.customizationInfo?.isUsgUIProduct === true;
              if(order?.lineItems[x][i]?.type === 'mainitem' && isUsg){
                product['proof'] = order?.lineItems[x][i]?.data?.digitalPrintProofRequired ? 1 : 0;
                product['comment'] = order?.lineItems[x][i]?.data?.specialInstructionsForLineItem ? 1 : 0;
              }
              if(order?.lineItems[x][i]?.type === 'mainitem'){
                product = {...product,...getCstmzrTypeInfoFromLS(order?.lineItems[x][i]?.data?.id)}
              }else if(order?.lineItems[x][i]?.type === 'upsell' || order?.lineItems[x][i]?.type === 'accessory'){
                product = {...product,...getCstmzrTypeInfoFromLS(order?.lineItems[x][i]?.data?.mainItemId)}
              }
              
              product['logo_dec'] = formatCurrencyForGa(product.logo, order?.fractionDigits);
              product['setup_dec'] = formatCurrencyForGa(product.setup, order?.fractionDigits);
              product['price'] = formatCurrencyForGa(product.price, order?.fractionDigits);
              if(isSubmitArtworkEvent){
                product['logo_fill_flag']=isLogoUploaded;
                product['text_fill_flag']=isTextFilled;
                product['comments_fill_flag']=areCommentsFilled;
                product['transaction_id']=order?.orderNumber;
              }

              if(isPurchaseEvent && order?.lineItems[x][i]?.type === 'mainitem'){
                product['productDiscountAtOrderLevel'] = order?.lineItems[x][i]?.data?.effectivePrice?.discount?.subtotalwithlogo ? 
                  getPriceValue(currencyFormatter(order?.lineItems[x][i]?.data?.effectivePrice?.discount?.subtotalwithlogo, order?.fractionDigits)).replace(/ /g,"") : 
                  ""
              }
              products.push(product)
          }
      }
  }
 return products;
}



const addMerchantCategory = (lineitemId) => {
  if (lineitemId) {
    const PdiObj = window.pdi.localStorage.get();
    return PdiObj && Object.keys(PdiObj).length && PdiObj[lineitemId]
      ? { merch_cat_key: PdiObj[lineitemId]?.merchCatKey, merch_cat: PdiObj[lineitemId]?.merchCat }
      : { merch_cat_key: 'Not-Applicable', merch_cat: 'Not-Applicable' };
  }
  return {};
};

export const DispatchArtworkInteractionEvent = (action, value, label?) => {
  const _metaData: any = {
    event : 'artwork_interaction',
    action : action,
    value : value,
  }
  if (label !== undefined) {
    _metaData.label = label;
  }
  dispatchGaAndFacebookEvent(_metaData);
}

export const DispatchContactUsPCCEvent = () => {
  const _metaData: any = {
    event : 'artwork_interaction',
    label : 'contact_us',
  }
  dispatchGaAndFacebookEvent(_metaData);
}
export const DispatchArtworkErrorsPCCEvent = () => {
  const _metaData: any = {
    event : 'errors',
    pcc :'true',
    errorDescription:"Custom text or logo required",
  }
  dispatchGaAndFacebookEvent(_metaData);
}

export const DispatchSubmitArtworkEvent = (order,isLogoUploaded,isTextFilled,areCommentsFilled,prevPageSource) => {
  const products = getProductsList(order,false,true,isLogoUploaded,isTextFilled,areCommentsFilled)
  const _metaData = {
    'event' : 'submit_artwork',
    'logo_fill' : isLogoUploaded,
    'transaction_id' : order?.orderNumber,
    'products': products,
    'text_fill': isTextFilled,
    'comments_fill': areCommentsFilled,
    'previous-page-pcc': prevPageSource,
    ...addPCCFlag(order?.hasPCCItem),
  }
  dispatchGaAndFacebookEvent(_metaData);
}

export const DispatchErrorsEvent = (errorDesc) => {
  const _metaData: any = {
    event : 'errors',
    errorDescription: errorDesc,
  }
  dispatchGaAndFacebookEvent(_metaData);
};

export function sendToGTM(obj) {
  const metaData = {
    event: 'web_vitals',
    wv_id: obj.id,
    label: obj.name,
    value: Math.round(obj.name === 'CLS' ? obj.delta * 1000 : obj.delta),
  };
  if (window?.np?.logGaEvent) {
    window.np.logGaEvent(metaData);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(metaData);
}